export function loadParentChildList(childList: any, parentList: any, permitForm: any): any {

    const parent = parentList
    const children = childList
    const distinctParents: string[] = []
    let parentProcessed = false;

    if (parent.length > 0) {

        for (let i = 0; i < parent.length; i++) {

            parentProcessed = false;

            if (distinctParents.includes(parent[i])) {
                parentProcessed = true;
            }

            const parentRadioGrp: any = document.getElementsByName(parent[i])
            if (!parentProcessed) {
                distinctParents.push(parent[i]);
                for (let k = 0; k < parentRadioGrp.length; k++) {
                    (<HTMLElement>parentRadioGrp[k]).addEventListener('change', () => {
                        parentClkHandler(children,parent,permitForm,parentRadioGrp[k]);
                    })
                }
            }

            if (permitForm.get(parent[i])?.value === "Y") {
                permitForm.get(children[i])?.enable()
            } else {
                permitForm.get(children[i])?.disable()
            }

        }
    }

}
function parentClkHandler(childList: any, parentList: any, permitForm: any, parentElem: any): void {
    const parent = parentList
    const children = childList
    for (let i = 0; i < parent.length; i++) {
        if (parent[i] === parentElem.name) {
            if (permitForm.get(parent[i])?.value === "Y") {
                permitForm.get(children[i])?.enable()
            } else {
                permitForm.get(children[i])?.setValue("")
                permitForm.get(children[i])?.disable()
            }
        }
    }


}